"use strict";

// Copyright 2017-2020 The MathWorks, Inc.
define(['./facade/LitElement'], function (LitElement) {
  'use strict'; // no-op (no operation) function

  const noOp = function () {};

  class WidgetBase extends LitElement {
    // Turn off shadow root
    createRenderRoot() {
      return this;
    }
    /**
     * Emits custom events from the widget.
     *
     * @param {string} eventName name of the event
     * @param {object} data an object with the
     * data that should be attached to the event
     * this ends up in the event's detail
     * @param {object} options an options object.
     * Can specify cancelable, bubbles (defaults
     * bubbles: false, canceable: false)
     */


    emit(eventName, data, options = {}) {
      let bubbles = options.bubbles || false;
      let cancelable = options.cancelable || false;
      let eventObj = new CustomEvent(eventName, {
        detail: data || {},
        bubbles: bubbles,
        cancelable: cancelable
      });
      this.dispatchEvent(eventObj);
    }
    /**
     * Listens on events that the widget throws.
     * @param {string} eventName The name of the event to listen on
     * @param {function} callback The function to call when the event occurs
     * @param {object} options an object that specifies if the event should be
     * passive, capture (defaults - passive: browser/event dependent,
     * capture: false)
     * @returns {object} - object with a remove function.  Calling remove twice
     * does nothing
     */


    on(eventName, callback, options = {}) {
      this.addEventListener(eventName, callback, options);
      let removeFn = this.removeEventListener.bind(this, eventName, callback, options);
      return {
        remove: function () {
          removeFn();
          removeFn = noOp;
        }
      };
    }

  }

  return WidgetBase;
});
//# sourceMappingURL=WidgetBase.js.map
